import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const StyledDiv = styled.div`
  width: 100%;
  display: inline-block;
  text-align: center;
  margin-top: ${props => props.marginTop || '10%'};
  margin-bottom: ${props => props.marginBottom || '0'};
`;

const StyledSpinner = styled.i`
  color: #48bfff;
  margin-top: ${props => props.marginTopSpinner || '30px'};
`;

const LoadingComponent = ({ marginBottom, marginTop, marginTopSpinner }) => (
  <StyledDiv
    className="loading-container"
    marginBottom={marginBottom}
    marginTop={marginTop}
  >
    <StyledSpinner
      marginTopSpinner={marginTopSpinner}
      className="fa-solid fa-spinner fa-spin fa-3x"
    />
  </StyledDiv>
);

LoadingComponent.propTypes = {
  marginBottom: PropTypes.string,
  marginTop: PropTypes.string,
  marginTopSpinner: PropTypes.string,
};

export default LoadingComponent;
